export const usersList = [
  {
    id: 1,
    name: 'Homer Simpson',
    pictureURL:
      'https://images.pexels.com/photos/2269872/pexels-photo-2269872.jpeg',
  },
  {
    id: 2,
    name: 'Marge Simpson',
    pictureURL:
      'https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg',
  },
  {
    id: 3,
    name: 'Lisa Simpson',
    pictureURL:
      'https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg',
  },
  {
    id: 4,
    name: 'Bart Simpson',
    pictureURL:
      'https://images.pexels.com/photos/2269872/pexels-photo-2269872.jpeg',
  },
];
